import React from "react";
import { Link } from "react-router-dom";
import useTypingAnimation from "../hooks/useTypingAnimation";

const LandingPage = () => {
  const { displayName, showCursor } = useTypingAnimation("tadgh", "tadhg o'brien");

  return (
    <div className="landing-page">
      <header>
        <h1 className="name" aria-label="tadhg o'brien">
          {displayName}
          {showCursor && <span className="cursor" aria-hidden="true">|</span>}
        </h1>
      </header>
      <main className="landing-page-links">
        <Link to="/projects" className="landing-page-link">projects</Link>
        <Link to="https://www.linkedin.com/in/tadhgobrien" className="landing-page-link" target="_blank" rel="noopener noreferrer">linkedin</Link>
      </main>
      <footer>
      </footer>
    </div>
  );
};

export default LandingPage;